'use client';
import Tags from "@/components/common/Tags";
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
    const {currentPost, postsBasePath} = useLoadPostBySlug("2025/11/masterclass-malekah");

    return (
        <PostContentFallback>
            <article>
                <div style={{ backgroundImage: `url(${currentPost?.image})` }} className={"h-[400px] w-full bg-cover bg-center relative"}>
                    <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                        <SectionPage sectionType={"2xl"}>
                            <h1 className={"text-white text-4xl font-exo"}>{currentPost?.title}</h1>
                        </SectionPage>
                    </div>
                </div>

                <SectionPage sectionType={"xl"} className={"my-12"}>
                    <div className="markdown-content text-gray-800">
                        <p className="my-4 text-normal leading-relaxed">
                            Le 24 septembre 2025, l'auditorium de l'UFR LTHR a accueilli une master class exceptionnelle sur le thème :
                            <span className="font-bold">« De l'audace d'espérer à l'audace de la réussite – DAD MINDSET »</span>
                            Cette rencontre a captivé l'auditoire grâce au parcours inspirant de Madame le Directeur Générale, ses conseils avisés et sa vision éclairée du leadership et de la réussite.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            L'audace comme moteur de réussite :
                        </p>

                        <ul className="list-disc list-inside my-4 pl-4 text-normal">
                            <li>Oser rêver et croire en soi</li>
                            <li>Transformer l'espoir en succès concret</li>
                            <li>Développer une vision claire et engagée pour atteindre ses objectifs</li>
                        </ul>

                        <div className={'my-8'}>
                            <ImageGallery images={
                                Array.from({ length: 4 }).map((_, index) => ({
                                    src: `/images${postsBasePath}/${String(currentPost?.slug)}/${index + 1}.JPG`,
                                    alt: `image${index + 1}`,
                                    width: 700,
                                    height: 700,
                                }))
                            } aspectRatio={"video"} />
                        </div>

                        <Tags tags={['DADMindset','AudaceEtReussite','Inspiration','Leadership','CôtedIvoire','CôtedIvoireTourisme']} />
                    </div>

                    <SimilarPosts currentSlug={String(currentPost?.slug)} />
                </SectionPage>
            </article>
        </PostContentFallback>
    );
}
